<template>
  <span :class="'text-'+badge.textColor +' bg-'+ badge.bgColor" class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium leading-4">
    {{badge.text}}
</span>  
</template>

<script>
export default {
    name: 'Badge',
    props: {
        badge:{
            type: Object,
            required: true
        }
    },
}
</script>

<style>

</style>